import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { PackagingComponentEntryDto } from 'src/app/data-transfer/entities/component-entities/packaging-component-entry-dto';
import { ExpenseCalculationCountryDto } from 'src/app/data-transfer/entities/evaluation-entities/expense-calculation-country-dto';
import { MultiMaterialCompositeDto } from 'src/app/data-transfer/entities/material-entities/multi-material-composite-dto';
import { PackagingSystemDto } from 'src/app/data-transfer/entities/packaging-system-entities/packaging-system-dto';
import { PackagingUnitDto } from 'src/app/data-transfer/entities/packaging-unit-entities/packaging-unit-dto';

@Component({
  selector: 'app-expense-calculation-parent',
  templateUrl: './expense-calculation-parent.component.html',
  styleUrls: ['./expense-calculation-parent.component.scss']
})
export class ExpenseCalculationParentComponent implements OnDestroy {

  protected packagingPartType!: number;

  protected routeDataSubscription?: Subscription;

  protected licenseFeeCountries!: ExpenseCalculationCountryDto[];
  protected ecomodulationCountries!: ExpenseCalculationCountryDto[];
  protected plasticTaxCountries!: ExpenseCalculationCountryDto[];

  ngOnDestroy(): void {
    this.routeDataSubscription?.unsubscribe();
  }
}
